import styles from './styles.module.scss'

import { Modal, Button } from 'antd';

import { Helmet } from 'react-helmet';

import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { UserContext } from '@/context/user';

import { UniversalAnalyticsAttribute } from '@/components/user_context/ua';
import { GoogleAnalytics4Attribute } from '@/components/user_context/ga4';
import { GoogleTagManagerAttribute } from '@/components/user_context/tag_manager';
import { GoogleOptimizeAttribute } from '@/components/user_context/optimize';
import { GoogleUserIdAttribute } from '@/components/user_context/user_id';
import { DebugModeAttribute } from '@/components/user_context/debug_mode';
import { CookieAttribute } from '@/components/user_context/cookie';

import { removeUserContexts } from '@/persistence/user_context';

export const PageManage = () => {
  const history = useHistory();

  const {
    ready,
    debugMode,
    ga4Attr,
    uaAttr,
    tagManagerAttr,
    optimizeAttr,
    userId,
    resetUserContext,
  } = useContext(UserContext)

  const [resetModalVisible, setResetModalVisible] = useState(false)

  const onResetClick = () => {
    setResetModalVisible(true)
  }

  const onReset = async () => {
    resetUserContext()
    await removeUserContexts()

    setResetModalVisible(false)

    window.location.reload()
  }

  const onAttributeSet = () => {
    // @ts-ignore
    const params = (new URL(window.document.location)).searchParams;
    const next = params.get('next')
    const require = params.get('require')

    if (next) {
      history.push(next)
    }

    window.location.reload()
  }


  return (
    <>
      <Helmet>
        <title>실습 환경 설정</title>
      </Helmet>
      <div className={styles.header}>
        <h2>실습 환경 설정</h2>
      </div>
      <div className={styles.description}>
        <p>실습 환경을 설정할 수 있습니다.</p>
      </div>
      <div className={styles.grid}>
        <div className={styles.gridItem}>
          <GoogleAnalytics4Attribute onDone={() =>{ onAttributeSet() }}/>
        </div>
        <div className={styles.gridItem}>
          <DebugModeAttribute />
        </div>
        <div className={styles.gridItem}>
          <GoogleUserIdAttribute />
        </div>
        <div className={styles.gridItem}>
          <UniversalAnalyticsAttribute />
        </div>
        <div className={styles.gridItem}>
          <GoogleTagManagerAttribute />
        </div>
        <div className={styles.gridItem}>
          <CookieAttribute />
        </div>
        {/* <div className={styles.col}>
          <GoogleOptimizeAttribute />
        </div> */}
      </div>
      <div className={styles.rowReset}>
        <Button type="dashed" danger onClick={(e) => onResetClick()}>모든 정보 초기화</Button>
      </div>

      <Modal
        title="모든 정보 초기화"
        visible={resetModalVisible}
        onOk={(e) => onReset()}
        onCancel={() => { setResetModalVisible(false) } }>
        <p>모든 정보를 초기화할 경우 실습이 제대로 진행되지 않을 수 있습니다.</p>
        <p>정말 모든 실습 정보를 초기화할까요?</p>
      </Modal>
    </>
  )
}
